import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navItems = [
  { label: "Αρχική", id: "hero" },
  { label: "Υπηρεσίες", id: "ypiresies" },
  { label: "Οι Χώροι μας", id: "choroi" },
  { label: "Φιλοσοφία", id: "filosofia" },
  { label: "Η Ομάδα μας", id: "omada" },
  { label: "Επικοινωνία", id: "epikoinonia" },
];

const LOGO_URL =
  "/images/logo.png";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    if (id === "hero") {
      navigate("/");
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    if (id === "choroi") {
      navigate("/oi-choroi-mas");
      return;
    }
    navigate(`/#${id}`);
  };

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "glass-header border-b-2 border-dashed border-brand-pink/60" : "bg-brand-bg"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <button
            data-testid="logo-button"
            onClick={() => handleNav("hero")}
            className="flex items-center gap-3 group"
          >
            <div className="w-14 h-14 rounded-2xl bg-white border-2 border-brand-yellow flex items-center justify-center overflow-hidden transition-transform group-hover:rotate-6">
              <img src={LOGO_URL} alt="Ορίζοντες Ανάπτυξης" className="w-full h-full object-contain" />
            </div>
            <div className="text-left leading-tight hidden sm:block">
              <div className="font-heading font-bold text-brand-text text-base">Ορίζοντες Ανάπτυξης</div>
              <div className="font-hand text-[14px] text-brand-primary leading-none">Κέντρο Ειδικών Θεραπειών</div>
            </div>
          </button>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <button
                key={item.id}
                data-testid={`nav-${item.id}`}
                onClick={() => handleNav(item.id)}
                className="px-4 py-2 rounded-full text-sm font-bold text-brand-text hover:bg-brand-yellowSoft hover:text-brand-primaryHover transition-colors"
              >
                {item.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              data-testid="header-contact-cta"
              onClick={() => handleNav("epikoinonia")}
              className="hidden md:inline-flex items-center px-6 py-3 rounded-full bg-brand-primary text-white font-bold text-sm hover:bg-brand-primaryHover transition-all shadow-[0_4px_0_#5B4F46] hover:translate-y-[2px] hover:shadow-[0_2px_0_#5B4F46]"
            >
              Επικοινωνία
            </button>
            <button
              data-testid="mobile-menu-toggle"
              onClick={() => setOpen(!open)}
              className="lg:hidden w-11 h-11 rounded-full bg-brand-yellow border-2 border-brand-text/20 flex items-center justify-center"
              aria-label="Μενού"
            >
              {open ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>

        {open && (
          <div data-testid="mobile-menu" className="lg:hidden pb-6 pt-2 flex flex-col gap-1 animate-fade-up">
            {navItems.map((item) => (
              <button
                key={item.id}
                data-testid={`mobile-nav-${item.id}`}
                onClick={() => handleNav(item.id)}
                className="text-left px-4 py-3 rounded-2xl text-base font-bold text-brand-text hover:bg-brand-yellowSoft transition-colors"
              >
                {item.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}
